import { derived, writable } from 'svelte/store';
import en from "../data/en";
const words = writable(en.split('\n'));
export const fiveLetterWords = derived(words, $words => $words.filter(word => word.length === 5));
export const boggleWords = derived(words, $words => $words.filter(word => word.length >= 3));
